import { defaultAnchorSpec, type AnchorSpec, type Category } from '@ar-suite/core'
import type { ProceduralFacePropOptions } from './procedural'

export interface ProceduralFacePropProduct {
  id: string
  name: string
  category: Category
  procedural: Partial<ProceduralFacePropOptions>
  anchor: AnchorSpec
}

function spec(category: Category, patch: Partial<AnchorSpec> = {}): AnchorSpec {
  const s = defaultAnchorSpec(category)
  s.unitScale = 1 // procedural models are authored in cm
  return Object.assign(s, patch)
}

export const PROCEDURAL_FACE_PROPS: ProceduralFacePropProduct[] = [
  {
    id: 'nose-stud-gold',
    name: 'Nose stud · Gold',
    category: 'nosepin',
    procedural: { style: 'nose-stud', color: 0xc22040, accent: 0xd4a94a },
    // sit on the outer nostril surface, a touch outward so it doesn't z-fight the skin
    anchor: spec('nosepin', { offset: [0.35, 0.15, 0.3] }),
  },
  {
    id: 'nose-ring-gold',
    name: 'Nose ring · Gold',
    category: 'nosepin',
    procedural: { style: 'nose-ring', accent: 0xd4a94a },
    anchor: spec('nosepin', { offset: [0.35, -0.05, 0.2] }),
  },
  {
    id: 'bindi-red',
    name: 'Bindi · Classic red',
    category: 'bindi',
    procedural: { style: 'bindi-round', color: 0xb01030 },
    anchor: spec('bindi', { offset: [0, -0.35, 0.25] }),
  },
  {
    id: 'bindi-teardrop',
    name: 'Bindi · Maroon teardrop',
    category: 'bindi',
    procedural: { style: 'bindi-teardrop', color: 0x7a0c26, accent: 0xd4a94a },
    anchor: spec('bindi', { offset: [0, -0.2, 0.25] }),
  },
  {
    id: 'tikka-kundan',
    name: 'Maang tikka · Kundan',
    category: 'tikka',
    procedural: { style: 'tikka', color: 0x1f7a4d, accent: 0xd4a94a },
    anchor: spec('tikka', { offset: [0, 0.4, 0.5] }),
  },
  {
    id: 'cap-navy',
    name: 'Cap · Navy',
    category: 'hat',
    procedural: { style: 'cap', color: 0x1d2a4a },
    anchor: spec('hat', { offset: [0, 0.2, 0], occluder: { type: 'head', depthOffset: 0, scale: 1.02 } }),
  },
  {
    id: 'beanie-grey',
    name: 'Beanie · Grey',
    category: 'hat',
    procedural: { style: 'beanie', color: 0x5a5a5f },
    anchor: spec('hat', { offset: [0, 1.0, 0], occluder: { type: 'head', depthOffset: 0, scale: 1.02 } }),
  },
  {
    id: 'headphones-black',
    name: 'Headphones · Black',
    category: 'hat',
    procedural: { style: 'headphones', color: 0x17171a, accent: 0x2c2c30 },
    anchor: spec('hat', { offset: [0, 0.4, 0], occluder: { type: 'head', depthOffset: 0, scale: 1.0 } }),
  },
]
